/*
Copyright 2019 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import toError from "./toError.js";
import updateErrorMessage from "./updateErrorMessage.js";

/**
 * Augments an error's message with additional context as it bubbles up the call stack.
 * @param {Object} options
 * @param {String} options.message The message to be added to the error.
 * @param {Error} options.error Optimally, this is an instance of Error. If it is not,
 * this is used as the basis for the message of a newly created Error instance.
 * @returns {*}
 */
export default ({
  error,
  message
}) => {
  const errorToStack = toError(error);
  const newMessage = `${message}\nCaused by: ${errorToStack.message}`;
  updateErrorMessage({
    error: errorToStack,
    message: newMessage
  });
  return errorToStack;
};